var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "fill-height align-start" },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(
                      _vm._s(
                        _vm.isNew
                          ? "Новый пользователь"
                          : "Редактирование пользователя"
                      )
                    ),
                  ]),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-form",
                        { attrs: { autocomplete: "off" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Имя" },
                            model: {
                              value: _vm.user.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.user, "name", $$v)
                              },
                              expression: "user.name",
                            },
                          }),
                          _c("v-text-field", {
                            attrs: { label: "Логин" },
                            model: {
                              value: _vm.user.login,
                              callback: function ($$v) {
                                _vm.$set(_vm.user, "login", $$v)
                              },
                              expression: "user.login",
                            },
                          }),
                          _c("v-text-field", {
                            attrs: {
                              "append-icon": _vm.showPassword
                                ? "mdi-eye"
                                : "mdi-eye-off",
                              type: _vm.showPassword ? "text" : "password",
                              label: "Пароль",
                              autocomplete: "new-password",
                            },
                            on: {
                              "click:append": function ($event) {
                                _vm.showPassword = !_vm.showPassword
                              },
                            },
                            model: {
                              value: _vm.user.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.user, "password", $$v)
                              },
                              expression: "user.password",
                            },
                          }),
                          _vm.hasRights("usersList")
                            ? _c("v-switch", {
                                attrs: { label: "Администратор" },
                                model: {
                                  value: _vm.user.isAdmin,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.user, "isAdmin", $$v)
                                  },
                                  expression: "user.isAdmin",
                                },
                              })
                            : _vm._e(),
                          _vm.hasRights("usersList")
                            ? _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.rights,
                                  chips: "",
                                  "deletable-chips": "",
                                  multiple: "",
                                  label: "Права доступа",
                                },
                                model: {
                                  value: _vm.user.rights,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.user, "rights", $$v)
                                  },
                                  expression: "user.rights",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$router.push({ name: "usersList" })
                            },
                          },
                        },
                        [_vm._v("К списку")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { large: "", color: "primary" },
                          on: { click: _vm.save },
                        },
                        [_vm._v("Сохранить")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }